import React from 'react'
import headlogo from '../../Images/Isolation_Mode.png'
import isolation from '../../Images/Isolation_Mode (1).png'
import isolation2 from '../../Images/Isolation_Mode (2).png'
import isolation3 from '../../Images/Isolation_Mode (3).png'
import Header2 from '../../Layout/Header2'
import './Pricingplans.css'
import Plans from './Plans'
const Pricingplans = () => {
  return (
    <>
    {/* This Section is taken from the about_us_section */}
          <section className='' >
    <div className='pricing_plans_container'>
        <Header2/>
        <div >
        <h1 className=' about_head'>Pricing Plans
        <span>
        <img className='img_logo2' src={headlogo}/>
        </span>
        </h1>
       <p className='about_head_para'>Lorem Ipsum placeholder text for use in your graphic, print and web layouts, and discover <br/> plugins for your favorite writing, design and blogging tools. </p>
        </div>
        <img className='isolation_img_5' src={isolation}/>
        <img className='isolation_img_6' src={isolation2}/>
 <img className='isolation_img_4' src={isolation3}/>

     </div> 
    </section>

    {/* The section ends here */}
    <Plans/>
    
    </>
  )
}

export default Pricingplans
